<template>
  <div class="envs">
    <div class="env ">
      <div class="swiper-c">
        <swiper :auto-update="true" class="actor-list" ref="mySwiper" :options="swiperOption">
          <swiper-slide class="swiper-slide" v-for="(item, index) in list" :key="index">
            <div class="env-con">
              <div class="logo">
                <img class="bg" :src="item.bg_url" />
                <img class="logo" :src="item.icon" />
              </div>
              <p class="name">{{ item.name }}</p>
              <p class="env-des">
                {{ item.description }}
              </p>
              <div class="env-info">
                <div class="datas">
                  <span class="tit">区块高度</span>
                  <span class="num">{{ toThousands(item.blocks) }}</span>
                </div>
                <div class="datas">
                  <span class="tit">交易数量</span>
                  <span class="num">{{ toThousands(item.transactions) }}</span>
                </div>
              </div>
              <Button class="btn" :disabled="item.state === 2" type="primary" @click="$router.push({ name: 'environment-detail', params: { id: item.id } })"
                >选择<span class="arrow">→</span></Button
              >
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
        <div class="swiper-pagination" slot="pagination"></div>
        <!-- 如果需要滚动条 -->
        <div class="swiper-scrollbar"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Button } from 'view-design'
export default {
  components: {
    Button
    // SwiperSlide,
    // Swiper
  },
  data() {
    return {
      list: [],
      index: undefined,
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 40,
        slidesPerGroup: 1,
        freeMode: true, // 随意拖动位置
        mousewheel: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        loop: false,
        // 如果需要滚动条
        scrollbar: '.swiper-scrollbar',
        loopFillGroupWithBlank: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表
    async getList() {
      const params = {
        uriCode: 'API006'
      }
      const res = await this.$fetch(params)
      this.list = res.list
    }
  }
}
</script>

<style lang="scss">
.envs {
  font-family: PingFangSC-Semibold, PingFang SC;
  // height: calc(100vh -60px);
  // height: 90vh;
  // height: calc(100vh - 60px);
  // overflow-y: auto;
  min-height: 700px;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    height: calc(100vh - 60px);
    min-height: 700px;
  }
  .swiper-c {
    width: 1354px;
    height: 640px;
    margin: auto;
    .actor-list {
      width: 1139px;
      height: 100%;
      padding: 30px 10px;
      box-sizing: border-box;
    }
    .swiper-pagination {
      width: 1354px;
      margin: -20px 0 auto;
      .swiper-pagination-bullet {
        width: 14px !important;
        height: 14px !important;
        text-align: center;
        opacity: 0.1;
        background-color: #999;
        margin: 0 4px;
        &:first-child {
          margin-left: 0px;
        }
        &:last-child {
          margin-right: 0px;
        }
      }
      .swiper-pagination-bullet-active {
        background-color: #468fef;
        opacity: 1;
      }
    }
    .swiper-button-prev,
    .swiper-container-rtl .swiper-button-next {
      border: 1px solid #d8d8d8;
      width: 72px;
      height: 72px;
      border-radius: 50%;
      margin-left: 43px;
    }
    .swiper-button-prev:hover {
      border-color: #468fef;
    }
    .swiper-button-prev:hover:after {
      color: #468fef !important;
    }
    .swiper-button-next:hover {
      border-color: #468fef;
    }
    .swiper-button-next {
      border: 1px solid #d8d8d8;
      width: 72px;
      height: 72px;
      border-radius: 50%;
      margin-right: 43px;
    }
    .swiper-button-prev:after {
      color: #d8d8d8;
      font-size: 26px;
    }
    .swiper-button-next:after {
      color: #d8d8d8;
      font-size: 26px;
    }
    .swiper-button-next:hover:after {
      color: #468fef !important;
    }
  }

  .ivu-carousel-arrow {
    width: 50px !important;
    height: 50px !important;
    .ivu-icon {
      margin: auto;
      margin-top: 16px;
    }
  }
  .title {
    font-size: 16px;
    color: #262626;
    line-height: 25px;
    margin: 10px 0;
  }
  .env {
    width: 100%;
    min-height: 554px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    .env-con {
      box-sizing: border-box;
      width: 373px;
      height: 554px;
      border-radius: 10px;
      background-color: #fff;
      margin-right: 19px;
      position: relative;
      transition: all 0.3s ease-out 0s;
      box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.03);
      &:hover {
        box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.08);
        transform: scale(1.02);
        z-index: 2;
        transition: all 0.1s ease-in-out;
      }
    }
    .logo {
      position: relative;
      text-align: center;
      height: 216px;
      display: flex;
      justify-content: center;
      .bg {
        position: absolute;
        top: 0;
        left: 0;
        height: 216px;
        width: 100%;
        img {
          height: 100%;
        }
      }
      .logo {
        width: 83px;
        height: 83px;
        margin: auto;
        border-radius: 50%;
      }
    }
    .env-des {
      margin-top: 5px;
      color: #666;
      line-height: 23px;
      font-size: 14px;
      width: 100%;
      height: 110px;
      // height: 132px;
      overflow: hidden;
      -webkit-line-clamp: 5;
      text-align: justify;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      padding: 0 40px;
    }
    .env-info {
      padding: 0 40px;
      width: 100%;
      margin: 0 auto;
      margin-top: 22px;
      display: flex;
      flex-direction: row;
      box-sizing: border-box;
      justify-content: space-between;
      .datas {
        // width: 40%;
        display: flex;
        flex-direction: column;
        text-align: left;
        .tit {
          color: #333333;
          line-height: 22px;
          font-size: 16px;
        }
        .num {
          font-weight: 900;
          color: #468fef;
          line-height: 33px;
          font-family: Arial-Black !important;
          font-size: 24px;
        }
      }
    }
    .name {
      font-size: 16px;
      margin: auto;
      text-align: center;
      margin-top: 23px;
      font-weight: 600;
      color: #1c2a34;
      line-height: 25px;
      padding: 0 40px;
    }
    h2 {
      height: 50px;
      line-height: 50px;
      padding: 0 20px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
    .btn {
      width: 166px !important;
      height: 37px !important;
      background: #fff !important;
      border: 1px solid #cccccc;
      border-radius: 2px;
      color: #666 !important;
      margin: auto;
      margin-top: 37px;
      .arrow {
        margin-left: 8px !important;
      }
    }
    .btn:hover {
      border-color: #468fef !important;
      color: #468fef !important;
    }
  }
}
</style>
